module.exports = __webpack_public_path__ + "static/media/3.898e67e8.png";